import { render } from "./FormModal.vue?vue&type=template&id=03860e0a"
import script from "./FormModal.vue?vue&type=script&lang=js"
export * from "./FormModal.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\Ned-ie\\ned_website-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__